import { Injectable } from "@angular/core";
import { Status } from "./status.model";
import { DatePipe } from "@angular/common";

export abstract class Person {

  constructor(protected _id?: number, protected _occupation?: string, protected _salary?: number, protected _salaryDay?: number, protected _icNumber?: string, protected _remark?: string, protected _status?: Status[], protected _dateCreated?: Date, protected _companyId?: number, protected _customerCode?: string, protected _companyCode?: string, protected _reserve?: number, protected _badDebt?: number) { }

  set ID(id: number) { this._id = id }
  get ID(): number { return this._id }

  set Occupation(occupation: string) { this._occupation = occupation }
  get Occupation(): string { return this._occupation }

  set Salary(salary: number) { this._salary = salary }
  get Salary(): number { return this._salary }

  set SalaryDay(salaryDay: number) { this._salaryDay = salaryDay }
  get SalaryDay(): number { return this._salaryDay }

  set ICNumber(icNumber: string) { this._icNumber = (icNumber ?? '').trim().replace(/-/g, "") }
  get ICNumber(): string { if (this._icNumber) return (this._icNumber ?? '').trim().replace(/-/g, "") }
  get ICNumberWithDash(): string { return this.formatICNumber(this._icNumber) }

  set Remark(remark: string) { this._remark = remark }
  get Remark(): string { return this._remark }

  set Status(status: Status[]) { this._status = status }
  get Status(): Status[] { return this._status }

  set DateCreated(dateCreated: Date) { this._dateCreated = dateCreated }
  get DateCreated(): Date { return this._dateCreated }

  set CompanyId(companyId: number) { this._companyId = companyId }
  get CompanyId(): number { return this._companyId }

  set CustomerCode(customerCode: string) { this._customerCode = customerCode }
  get CustomerCode(): string { return this._customerCode }

  set Reserve(reserve: number) { this._reserve = reserve }
  get Reserve(): number { return this._reserve }

  set BadDebt(badDebt: number) { this._badDebt = badDebt }
  get BadDebt(): number { return this._badDebt }

  set CompanyCode(companyCode: string) { this._companyCode = companyCode }
  get CompanyCode(): string { return this._companyCode }

  private formatICNumber(icNumber: string) {
    if (icNumber == undefined) return '';
    const icNumberFormat = icNumber.replace(/-/g, "",);
    let output = "";
    for (let i = 0; i < icNumberFormat.length; i++) {
      output += icNumberFormat[i];
      if (i == 5 || i == 7)
        output += "-"
    }
    return output;
  }
}

export interface IAPIPerson {
  id: number;
  occupation: string;
  salary: number;
  salaryDay: number;
  icNumber: string;
  remark: string;
  status: number[];
  dateCreated: string;
  companyId: number;
  customerCode: string;
  companyCode: string;
  reserve: number;
  badDebt: number;
}

@Injectable({
  providedIn: 'root'
})
export abstract class PersonAdapter {

  constructor(private datePipe: DatePipe) { }

  abstract adapt(item: any): Person;
  abstract toApiModel(p: Person): IAPIPerson;

  transformDate(aDate: Date): string {
    return this.datePipe.transform(aDate, 'yyyy-MM-dd');
  }

  protected processCustomerStatus(status: number[]): Status[] {
    if (status && status.length > 0) {
      let statusList: Status[] = [];

      const statusMap = status.reduce((map, code) => {
        map.set(code, (map.get(code) || 0) + 1);
        return map;
      }, new Map<number, number>());

      statusList = Array.from(statusMap.entries()).map(([code, occurrence]) => new Status(code, occurrence));

      statusList.sort((a, b) => (a.StatusCode > b.StatusCode) ? 1 : -1);

      return statusList;
    }
  }

}